import React from "react"
import { Dialog, Button, Typography, Box, IconButton } from "@mui/material"
import { styled } from "@mui/material/styles"
import CloseIcon from "@mui/icons-material/Close"
import { useLocation } from "react-router-dom"
import { openAppOrStore } from "../utils/deviceDetection"
import "./AppDownloadModal.css"
import "../App.css"

const StyledDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialog-paper": {
    borderRadius: "16px",
    margin: "16px",
    maxWidth: "400px",
    width: "calc(100% - 32px)",
  },
}))

const AppIcon = styled("img")({
  width: "64px",
  height: "64px",
  borderRadius: "12px",
  marginBottom: "16px",
})

const AppDownloadModal = ({ open, onClose, operatingSystem }) => {
  const location = useLocation()

  const handleOpenApp = () => {
    openAppOrStore(location.pathname)
    onClose()
  }

  const getAppIcon = () => {
    return "Selo_5.svg"
  }

  const getOSName = () => {
    return operatingSystem === "ios" ? "iOS" : "Android"
  }

  return (
    <StyledDialog
      open={open}
      onClose={onClose}
      aria-labelledby="app-download-modal"
      maxWidth="sm"
      fullWidth
      className="app-download-modal"
    >
      <Box sx={{ position: "relative", p: 3, textAlign: "center" }}>
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: "var(--text-color)",
            "&:hover": {
              backgroundColor: "rgba(242, 225, 209, 0.1)",
            },
          }}
        >
          <CloseIcon />
        </IconButton>

        <AppIcon src={getAppIcon()} alt="Cosmo App" />

        <Typography
          variant="h6"
          component="h2"
          gutterBottom
          sx={{
            fontWeight: "bold",
            color: "var(--text-color)",
            fontFamily: "'InterTight', sans-serif",
          }}
        >
          Acesse pelo App
        </Typography>

        <Typography
          variant="body2"
          sx={{
            mb: 3,
            color: "var(--secondary-color)",
            fontFamily: "'InterTight', sans-serif",
          }}
        >
          Tenha uma experiência melhor com o nosso app oficial para{" "}
          {getOSName()}
        </Typography>

        <Button
          variant="contained"
          fullWidth
          onClick={handleOpenApp}
          className="app-download-button"
          sx={{
            py: 1.5,
            borderRadius: "4px",
            textTransform: "none",
            fontSize: "16px",
            fontWeight: "600",
            fontFamily: "'InterTight', sans-serif",
          }}
        >
          Quero usar o App
        </Button>

        <Button
          variant="text"
          fullWidth
          onClick={onClose}
          sx={{
            mt: 1,
            color: "var(--secondary-color)",
            textTransform: "none",
            fontFamily: "'InterTight', sans-serif",
            "&:hover": {
              backgroundColor: "rgba(186, 181, 200, 0.1)",
            },
          }}
        >
          Continuar no navegador
        </Button>
      </Box>
    </StyledDialog>
  )
}

export default AppDownloadModal
